'use strict';

var app = angular.module('angNewsApp', []);
